export const CoreInitiativesLinksName = 'CoreInitiativesLinks';
